import React from 'react';
import PropTypes from 'prop-types';

import './Tooltip.css';

export function Tooltip({ title, children }) {
  return (
    <div
      className="icon"
      data-tooltip={title}
    >
      {children}
    </div>
  );
}

Tooltip.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node
};

export default Tooltip;
